module.exports = __webpack_public_path__ + "static/media/SCR-A-new5.4535dfda.mp3";